function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

import RootElem from './RootElem';
/**
 * A input component
 */

var Input =
/*#__PURE__*/
function (_RootElem) {
  _inherits(Input, _RootElem);

  /**
   * Creates an instance of Input
   * @param {string} value Initial value.
   * @param {object} [opt] Optional parameters.
   * @param {string} [opt.className] Class name
   * @param {object} [opt.attributes] Key/value attributes object
   * @param {object} [opt.events] Key/value events object, where the key is the event name, and value is the callback.
   */
  function Input(value, opt) {
    _classCallCheck(this, Input);

    opt = Object.assign({
      attributes: null,
      properties: null
    }, opt);
    opt.attributes = Object.assign({
      type: 'text'
    }, opt.attributes, {
      value: value
    });
    opt.properties = Object.assign({}, opt.properties, {
      value: value
    });
    return _possibleConstructorReturn(this, _getPrototypeOf(Input).call(this, 'input', opt));
  }
  /**
      * Gets the value
   * @returns {string}
     */


  _createClass(Input, [{
    key: "getValue",
    value: function getValue() {
      return this.getProperty('value');
    }
    /**
     * Sets the value
     * @param {string} value Value
     * @returns {this}
     */

  }, {
    key: "setValue",
    value: function setValue(value) {
      this.setProperty('value', value);
      return this;
    }
  }]);

  return Input;
}(RootElem);

export default Input;